import { Component } from '@angular/core';
import { BaseComponent } from '../../../../base.component';
import { ProcessingStep } from '@models/ui/processing-step.model';
import { Router } from '@angular/router';
import { PagingResponse } from "@models/paging-response.model";
import { CasePriority } from "@models/case-priority.model";
import { CasePriorityService } from "@services/case-priority.service";
import { map, Observable } from "rxjs";

@Component({
    selector: 'lex-case-priorities',
    templateUrl: './case-priorities.component.html',
    styleUrls: ['./case-priorities.component.scss'],
    standalone: false
})
export class CasePrioritiesComponent extends BaseComponent {
	public currentStep: ProcessingStep;
	public casePriorities$: Observable<CasePriority[]> = this.casePriorityService.getCasePriorities(0, 100, "").pipe(map((data: PagingResponse<CasePriority>) => data.value));

	constructor(
		private router: Router,
		private casePriorityService: CasePriorityService
	) {
		super();

	}

	public close(): void {
		this.currentStep = null;
		this.router.navigate(['/', 'processing', 'queue', 'snapshot']);
	}

	public setCasePriority(casePriority: CasePriority): void {
		this.casePriorityService.setCasePriority(casePriority)
			.subscribe();
	}
}
